import React, { FC } from 'react';
import { getStoredLanguage, isAccountImpersonated } from '@dev/ee-tools';

import { IntercomProvider } from 'react-use-intercom';
import { IntercomProviderInterface } from './Interface';
import { isIntercomEnabled } from '../Security';
import { parse } from 'query-string';

// we need to pass if the account is impersonated or not to our gtm to be able to shoutdown intercom for impersonated acounts

(() => {
    try {
        const queryParams = parse(window.location.search, { decode: false });
        const impersonated = isAccountImpersonated() || !!queryParams?.t;
        const locale = getStoredLanguage();

        //eslint-disable-next-line
        //@ts-ignore
        window.meta = {
            ...(window as any)?.meta,
            impersonated,
            locale,
        };
    } catch {
        console.log('could not set meta');
    }
})();

export const OptionalIntercomProvider: FC<IntercomProviderInterface> = ({ children }: IntercomProviderInterface): JSX.Element => {
    const queryParams = parse(window.location.search, { decode: false });

    return (
        <IntercomProvider
            appId={INTERCOMKEY}
            autoBoot={isIntercomEnabled() && !queryParams?.t}
            shouldInitialize={isIntercomEnabled() && !queryParams?.t}
        >
            {children}
        </IntercomProvider>
    );
};
